import { FeatureFlagService } from './feature-flags.service';

// Factory function consumed by APP_INITIALIZER in AppModule.
// Angular calls this before the router starts. Returning a Promise makes
// Angular wait for it to resolve before continuing bootstrap.
export function featureFlagInitializer(svc: FeatureFlagService): () => Promise<void> {
  return () => svc.loadNavFlags();
}